import React, { useContext } from "react";
import SimpleContext from "./../context/SimpleContext";
import headphones from "../img/headphones.png";
import menu from "../img/menu.png";
import { useHistory } from "react-router";

const Header = () => {
  const context = useContext(SimpleContext);
  const history = useHistory();

  return (
    <div className="otherPagesHeader">
      <div className="barbuttonn">
        <img
          onClick={context.drawerToggleClickHandler}
          style={{ width: "30px", height: "30px" }}
          src={menu}
        />
        {Object.values(context.festivalData).length > 0 && (
          <div onClick={() => history.push("/userPonits")}>
            <img style={{ width: "60px" }} src="/images/seke.png" />
            <span>{context.festivalData.pointSum}</span>
          </div>
        )}
      </div>
      <div className="headersNames">
        <h6 style={{ fontWeight: "bold" }}>اپی پخش</h6>
      </div>

      <div
        className="searchbtnn"
        onClick={() => history.push("/chatWithAdmin")}
      >
        <img style={{ width: "30px" }} src={headphones} />
      </div>
    </div>
  );
};

export default Header;
